import { yup } from 'common/validation/initYup';
import { validateYupSchema, yupToFormErrors } from 'formik';
import { ObjectShape } from 'yup/lib/object';
import { ValidateOptions } from 'yup/lib/types';

/**
 * Crea un validatore di uno schema per i form che non abbia solamente
 * `abortEarly`.
 *  `valuesToContext`: Se true passa al context del validatore i values del formik (accessibili come $values)
 */
export function schemaToValidator<T extends ObjectShape>(
  schema: yup.ObjectSchema<T>,
  options?: ValidateOptions,
  valuesToContext?: boolean
) {
  return async (values: any) => {
    try {
      const res = await schema.validate(values, {
        ...options,
        abortEarly: false,
        context: {
          ...options?.context,
          ...(valuesToContext ? { values } : {})
        }
      });
      return;
    } catch (err: any) {
      console.error('Validation error', err.errors, err.inner, err, values);
      return yupToFormErrors(err);
    }
  };
}
